var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axiosInstance from '@/config/axios.config';
import apiRequest from './api-service';
export var getAllJobSuggestion = function (search, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.get('job-search-auto-suggestion', {
                        params: { search: search },
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response || []];
        }
    });
}); };
export var getAllJobs = function (page, filters, sortBy, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    var params = {
                        page: page,
                    };
                    if (filters) {
                        var _loop_1 = function (key) {
                            if (filters[key]) {
                                if (Array.isArray(filters[key])) {
                                    filters[key].forEach(function (value) {
                                        params[key] = params[key] ? __spreadArray(__spreadArray([], params[key], true), [value], false) : [value];
                                    });
                                }
                                else {
                                    params[key] = filters[key];
                                }
                            }
                        };
                        for (var key in filters) {
                            _loop_1(key);
                        }
                    }
                    if (sortBy) {
                        params['sort_by'] = sortBy;
                    }
                    var queryString = Object.keys(params)
                        .map(function (key) {
                        if (Array.isArray(params[key])) {
                            return params[key]
                                .map(function (value) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)); })
                                .join('&');
                        }
                        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
                    })
                        .join('&');
                    return axiosInstance.get("job-search".concat(queryString ? "?".concat(queryString) : ''));
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, {
                        data: (response === null || response === void 0 ? void 0 : response.jobsData) || [],
                        total: (response === null || response === void 0 ? void 0 : response.count) || 0,
                        defaultSearch: (response === null || response === void 0 ? void 0 : response.defaultSearch) || false,
                    }];
        }
    });
}); };
export var likeJob = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.patch('job-like', {
                        job_id: payload.jobId,
                        liked: payload.liked,
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
export var getAllJobComments = function (jobId, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.get("job-comment/".concat(jobId));
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || []];
        }
    });
}); };
export var addJobComment = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.post('job-comment/', {
                        job_id: payload.jobId,
                        comment: payload.comment,
                        replied_to_comment_id: payload.repliedToCommentId,
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
export var likeJobComment = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.post('job-like-comment/', {
                        comment_id: payload.commentId,
                        liked: payload.liked,
                        main_comment_id: payload.mainCommentId,
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
export var deleteJobComment = function (commentId, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.delete("update-delete-job-comment/".concat(commentId, "/"));
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.job_comment_id) || null];
        }
    });
}); };
export var getJobCommentReplies = function (jobId, commentId, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.get("job-comment/".concat(jobId, "/"), {
                        params: {
                            replied_to_comment_id: commentId,
                        },
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || []];
        }
    });
}); };
export var editJobComment = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.patch("update-delete-job-comment/".concat(payload.commentId, "/"), {
                        comment: payload.comment,
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
export var uploadResume = function (file, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var formData, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                formData = new FormData();
                formData.append('file', file);
                formData.append('action', 'parse');
                return [4 /*yield*/, apiRequest(function () {
                        return axiosInstance.patch('upload-resume-new-user/', formData);
                    }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response || null];
        }
    });
}); };
export var applyJobViaEmail = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.post('auth/email-signup-new-user/', payload);
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response || null];
        }
    });
}); };
export var getJobDetails = function (jobId, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.get("job-details/".concat(jobId, "/"));
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.jobDetails) || null];
        }
    });
}); };
export var getSimilarJobs = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.get("get-candidate-similar-jobs/".concat(payload.jobId, "/"), {
                        params: payload.params,
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.jobsData) || []];
        }
    });
}); };
export var getMyJobStatus = function (jobId, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.get("my-job-status/", {
                        params: {
                            job_id: jobId,
                        },
                    });
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data) || null];
        }
    });
}); };
export var applyJobViaAuth = function (payload, onError) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, apiRequest(function () {
                    return axiosInstance.post("auth/".concat(payload.type, "/"), payload);
                }, onError)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response || null];
        }
    });
}); };
